import { ReactElement } from "react";
import cn from "classnames";

import { FormattedMessage } from "react-intl";

import { SEO } from "@/ui-components/commonComponents/SEO/SEO";

import logo from "@/assets/image/psp-logo.svg";

import style from "./style.module.css";

interface IErrorPage {
  isSignedIn: boolean;
  isAdmin: boolean;
  isClient: boolean;
  errorReason: string | null;
  children?: ReactElement;
}

export default function ErrorPage({ isSignedIn, isAdmin, isClient, errorReason, children }: IErrorPage) {
  return (
    <div className={cn(style.wrapper, { [style.pageWithHeaderWrapper]: isAdmin || isClient })}>
      <SEO titleParams={["Error"]} />
      <div className={style.logo}>
        {!isSignedIn && <img src={logo} alt="PSP Metrics" className={style.logoImage} />}
      </div>

      <div className={style.errorContainer}>
        <p className={style.title}>
          <FormattedMessage id="common.errorHeading" defaultMessage="Error" />
        </p>
        <p className={style.reason}>{errorReason}</p>
        {children}
      </div>
    </div>
  );
}
